import { createResource, RouterContext } from 'react-resource-router';

import { NavigationData } from 'src/types/navigation';
import { urls } from 'src/urls/projects';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

export type ProjectNavigation = NavigationData & {
  project: BB.Project;
};

export const fetchProjectNavigationData = async (
  workspaceSlug: string,
  projectKey: string
): Promise<ProjectNavigation | null> => {
  const url = urls.api.internal.navigation(workspaceSlug, projectKey);
  const response = await fetch(authRequest(url, { headers: jsonHeaders }));

  if (!response.ok) {
    throw new Error(
      `Error fetching project navigation data (${response.status}): ${response.statusText}`
    );
  }

  return response.json();
};

export const projectNavigationResource = createResource({
  type: 'PROJECT_NAVIGATION',
  getKey: ({ match }: RouterContext) => {
    const { workspaceSlug, projectKey } = match.params;
    return `project:${workspaceSlug}/${projectKey}`;
  },
  maxAge: 1000 * 60 * 10, // 10 minute
  getData: ({ match }): Promise<ProjectNavigation | null> => {
    const { workspaceSlug, projectKey } = match.params;
    if (!workspaceSlug || !projectKey) {
      throw new Error('workspace and project are required');
    }
    return fetchProjectNavigationData(workspaceSlug, projectKey);
  },
});
